import React, { Component } from "react";
import { Grid, Header, Button, Segment, Transition } from 'semantic-ui-react';

class Step4 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      animation: props.animation
    };

    this.transitionBack = this.transitionBack.bind(this);
    this.transitionNext = this.transitionNext.bind(this);
  }

  componentDidMount() {
    this.setState({
      visible: true
    });
  }

  transitionBack() {
    const { changeStep } = this.props;

    this.setState({
      animation: "fade left",
      visible: !this.state.visible
    });
    setTimeout(() => {
      changeStep(3, "fade right")
    }, 400);
  }

  transitionNext() {
    const { changeStep } = this.props;

    this.setState({
      animation: "fade right",
      visible: false
    });
    setTimeout(() => {
      changeStep(5, "fade left")
    }, 400);
  }

  render() {
    const { visible, animation } = this.state;

    return <div>
      <div className="back--icon" onClick={this.transitionBack}></div>
      <Transition visible={visible} duration={500} animation={animation}>
        <div>
          <Header className='title__main' as='h1' textAlign='center'>170 Lees Ave, Ottawa</Header>
          <Grid className='instant-activation width__xs'>
            <Grid.Row className="py-0">
              <Grid.Column className="px-0">
                <Segment inverted textAlign='center'>
                  <div className="circle-tick">
                  </div>
                  <Header as='h3' className="title" textAlign='center'>Available</Header>

                  <Segment className="sub__instant-activation mx-4" textAlign='center'>
                    <Header as='h5' className="itc-std-md">YOU JUST NEED A FIBRE JACK</Header>
                    <p className='text-white'>
                      We can have one of our technicians wire up your unit in no time.
                    </p>
                  </Segment>
                  <Button className='btn--full' size='medium' onClick={this.transitionNext}>Get Fibre Now</Button>
                </Segment>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row className="px-4 learn-more__text">
              <Grid.Column textAlign='center'>
                <p className="itc-std-md">All services are provided on a month to month basis with free installation and no contracts. Cancel anytime, risk free. <a className="text-prime">Learn more…</a></p>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Transition>
    </div>
  };
}

export default Step4;


// WEBPACK FOOTER //
// ./src/components/check-availability/service-not-available/Step4.js